import t_01_0509 from '././almaty/KZ.T.01.0509.svg'
import t_01_0509_b from '././almaty/KZ.T.01.0509 black.svg'

export default [
  t_01_0509,
  t_01_0509_b
]
